"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAppStore = createAppStore;
exports.store = exports["default"] = void 0;
var _redux = require("redux");
var _reduxThunk = _interopRequireDefault(require("redux-thunk"));
var _reduxLogger = require("redux-logger");
var _reduxPersist = require("redux-persist");
var _storage = _interopRequireDefault(require("redux-persist/lib/storage"));
var _reactReduxI18n = require("react-redux-i18n");
var _configuration = require("./configuration");
var _Reducers = _interopRequireDefault(require("./Reducers"));
var _Reducer = _interopRequireDefault(require("./Reducers/Device/Reducer"));
var _Reducer2 = _interopRequireDefault(require("./Reducers/Reducer"));
var _i18n = require("../Framework/i18n");
var _GeneralActions = require("./Reducers/GeneralActions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var reduxPersistConfig = (0, _configuration.getConf)('reduxPersist', {
  enabled: false
});
var rootReducer;

// adding core reducers
var reducers = _objectSpread(_objectSpread({}, _Reducers["default"]), {}, {
  i18n: _reactReduxI18n.i18nReducer,
  device: _Reducer["default"],
  api: _Reducer2["default"]
});
if (reduxPersistConfig.enabled && 'storeConfig' in reduxPersistConfig) {
  var persistConfig = _objectSpread({
    key: 'root',
    storage: _storage["default"]
  }, reduxPersistConfig.storeConfig);
  rootReducer = (0, _reduxPersist.persistCombineReducers)(persistConfig, reducers);
} else {
  rootReducer = (0, _redux.combineReducers)(reducers);
}
var middleware = [_reduxThunk["default"]];
if (process.env.NODE_ENV === 'development') {
  middleware.push((0, _reduxLogger.createLogger)());
}
function createAppStore() {
  return (0, _redux.createStore)(rootReducer, _redux.applyMiddleware.apply(void 0, middleware));
}
var store = exports.store = createAppStore();
if (reduxPersistConfig.enabled) {
  (0, _reduxPersist.persistStore)(store);
}

// the first action to set the initial states (in the custom project)
store.dispatch((0, _GeneralActions.setInitialState)());

// translation setup
(0, _reactReduxI18n.syncTranslationWithStore)(store);
// setup
(0, _i18n.setStore)(store, (0, _configuration.getConf)('language'));
var _default = exports["default"] = store;